import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export const useHandleCollabError = (flags: FlagsStateContainer): (() => void) => {
	const { formatMessage } = useIntl();

	return useCallback(() => {
		void flags.showErrorFlag({
			title: formatMessage({ id: 'collab.status.error' }),
			description: formatMessage({
				id: 'collab.status.tooltip.error',
			}),
		});
	}, [flags, formatMessage]);
};
